import React, { useState } from 'react';
import Img from './Img';
import MarketInfo from './MarketInfo';
import CashoutBadge from './CashoutBadge';
import FavoritesMarketToggle from './favorite-markets/FavoriteMarketsToggle';
import { getBetDescription } from '../data/utils';

export default function BetWrapper(props) {
    const data = props.data;
    const [toggled, setToggled] = useState(props.toggled);

    return (
        <div className="c_21">
            <div className="c_21_1" onClick={() => setToggled(!toggled)}>
                <FavoritesMarketToggle id={data.id} />
                <span className="c_21_1_2">{props.desc || getBetDescription(data)}</span>
                <div className="c_21_1_3">
                    <CashoutBadge bet={data} />
                    {data.hasOddTooltips &&
                        <MarketInfo desc={data.desc} odds={data.odds} />
                    }
                    <Img className="c_21_1_3_1" src="icon_chevron.svg" height="24px" width="24px" data-rotate={toggled ? '180' : '0'} pointer="true" />
                </div>
            </div>
            {toggled && props.children}
        </div>
    );
}
